<template>
	<div class="about">
		<div class="about-banner">
			<img v-for="item in bannerList" :src="item.coverUrl" :key="item.id" :data="item" />
		</div>
		<div class="about-content">
			<div class="about-us" v-html="about.content" />
			<div class="interview-title">
				<p class="test">{{ $t('previousForums') }}</p>
			</div>
			<div class="previous-Forums">
				<div class="previous-Forums-item" v-for="item in forumsList">
					<a :href="JSON.parse(item.ext).linkUrl" target="_blank">
						<img :src="JSON.parse(item.ext).coverUrl" alt="往届论坛封面图片" />
					</a>
					<p class="previous-Forums-title" :title="item.name">{{item.name}}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				about: {},
				forumsList: [],
				bannerList: []
			}
		},
		mounted() {
			this.getBanner()
			this.getData()
			this.getDictionaryList()
		},
		methods: {
			async getBanner() {
				const { data } = await this.$axios.$get('/forum/banner/list', {
					params: {
						platform: 1,
						position: 3
					}
				})
				this.bannerList = data
			},
			async getData() {
				let data = await this.$axios.$get('/forum/article', { params: { type: 1 } })
				this.about = data.data || {}

			},
			async getDictionaryList() {
				let data = await this.$axios.$get(`/forum/dictionary/15`)
				this.forumsList = data.data || []
			}
		},
		computed: {
			router() {
				return [{
					link: '',
					name: this.$t('aboutUs')
				}, {
					link: '',
					name: this.about.label
				}]
			}
		}
	}
</script>
<style lang="scss" scoped>
	.about {
		background: #F8F8F8;
		padding-bottom: 50px;

		.about-banner {
			height: 500px;

			img {
				height: 100%;
				width: 100%;
				object-fit: cover;
			}
		}

		.about-content {
			width: 1200px;
			margin: -100px auto 0;
			position: relative;
			z-index: 2;

			.about-us {
				background: #FFFFFF;
				border-radius: 6px;
				padding: 44px;
				margin-bottom: 20px;
			}

			.interview-title {
				width: 1200px;
				height: 64px;
				background: #FFFFFF;
				border-radius: 6px;
				padding: 20px 10px;
				margin-bottom: 2px;

				.test {
					font-size: 24px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					color: #333333;
					border-left: 4px solid #0D51FF;
					height: 24px;
					padding-left: 5px;
					line-height: 24px;
				}
			}

			.previous-Forums {
				height: 306px;
				background: #FFFFFF;
				border-radius: 0px 0px 6px 6px;
				display: flex;
				align-items: center;
				justify-content: center;

				.previous-Forums-item {
					width: 373px;
					margin-right: 21px;
					border: 1px solid #EEEEEE;

					&:last-child {
						margin-right: 0;
					}

					.nuxt-link-active {
						height: 160px;
						display: block;

						img {
							height: 160px;
							width: 100%;
							object-fit: cover;
						}
					}

					.previous-Forums-title {
						height: 46px;
						text-align: center;
						line-height: 46px;
						padding: 0 10px;
						margin: 0;
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #333333;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
					}
				}
			}
		}
	}
</style>